module.exports = (__webpack_require__(37062))(3827);